import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import {
  InformationWidgetComponent,
  InfoWidgetConfig
} from './information-widget.component';
import { AbstractInformationWidgetComponent } from './abstract.information-widget.component';
import { SliderComponent } from '../slider/slider.component';
import { SliderItemElementDirective } from '../../directives/slider-item-element.directive';
import { SliderItemDirective } from '../../directives/slider-item.directive';

@NgModule({
  declarations: [
    InformationWidgetComponent,
    AbstractInformationWidgetComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SliderComponent,
    SliderItemElementDirective,
    SliderItemDirective,
    TranslateModule
  ],
  exports: [
    InformationWidgetComponent,
    AbstractInformationWidgetComponent
  ],
  providers: [
    {
      provide: InfoWidgetConfig,
      useValue: {
        component: AbstractInformationWidgetComponent
      }
    }
  ]
})
export class InformationWidgetModule { }
